<template>
  <vue-content-loading v-bind="$attrs" :width="600" :height="225">
    <rect x="0" y="0" rx="1" ry="1" width="100%" height="200" />
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'sales',
  components: {
    VueContentLoading,
  },
};
</script>

<style scoped>

</style>
